<template>
  <div>
    <div
      class="index-index-bombscreen"
      :style="'background-color: rgba(0,0,0,' + bombScreenList[bombScreenIndex-1].maskOpacity/100 + ')'"
      v-if="bombStatus"
    >
      <div class="index-bombscreen-messa" @click.stop>
        <div class="image">
          <img :src="bombScreenList[bombScreenIndex-1].bgImage" />
        </div>
        <div class="button1" v-if="bombScreenList[bombScreenIndex-1].popupStyle==1">
          <img
            :src="bombScreenList[bombScreenIndex-1].button1Image"
            @click="onJumpSceneDetail(bombScreenList[bombScreenIndex-1],'button1Target')"
          />
          <img
            :src="bombScreenList[bombScreenIndex-1].button2Image"
            @click="onJumpSceneDetail(bombScreenList[bombScreenIndex-1],'button2Target')"
          />
        </div>
        <div class="button2" v-if="bombScreenList[bombScreenIndex-1].popupStyle==2">
          <img
            :src="bombScreenList[bombScreenIndex-1].button1Image"
            @click="onJumpSceneDetail(bombScreenList[bombScreenIndex-1],'button1Target')"
          />
        </div>
      </div>
      <div class="index-bombscreen-cancel">
        <img src="@/assets/home/bomb_cancel@2x.png" @click="onGetBombHidden" />
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/utils/common";
import http from "@/utils/axios";
export default {
  data() {
    return {
      bombStatus: false,
      bombScreenList: [],
      bombScreenIndex: 1,
      queryCount:1, //请求次数-仅订单支付成功页用
      shopId: this.$route.query.shopId||'',
      orderCode: this.$route.query.orderCode||''
    };
  },
  props: {
    pageCode: {
      default: "1",
      type: String,
    },
    refresh: {
      default: false,
      type: Boolean,
    },
  },
  created() {
    setTimeout(() => {
      this.onGetBombScreen();
    }, 500);
  },
  methods: {
    onGetBombScreen: function () {
      let randomKey = localStorage.getItem("uuid");
      if (!randomKey) {
        randomKey = this.get_uuid();
      }
      let temp_shoId = Array.isArray(this.shopId) ? this.shopId.pop() : this.shopId;
      let temp_orderCode = Array.isArray(this.orderCode) ? this.orderCode.pop() : this.orderCode;
     
      let current_data = {
        shopId:temp_shoId || 1,
        orderCode:temp_orderCode,
        pageCode: this.pageCode,
        randomKey: randomKey,
      };
      localStorage.setItem("uuid", randomKey);
      http({
        url: "/order/app/popup-rule/availablePopupRule",
        method: "post",
        parmes: current_data,
      }).then((rps) => {
        if (rps.code === 200) {
          this.bombStatus = rps.data.length == 0 ? false : true;
          this.bombScreenList = rps.data;
          this.bombScreenIndex = 1;
          if (this.bombScreenList && this.bombScreenList.length != 0) {
            gio("track", "popScreanExpore_var", {
              popScreanID_var: this.bombScreenList[0].id,
              popScreanClick_var: this.bombScreenList[0].name,
            });
          }
          //若支付成功页调用此子组件且没有广告返回的话，轮询此接口5次反复确认是否没广告。
          //原因：调用支付结果接口比较久，广告接口是否展示后台背后的逻辑之一是当前用户是否支付成功
          if(this.pageCode == '2' && !this.bombStatus && this.queryCount<5){
            this.queryCount++;
            this.onGetBombScreen();
          }
        }
        gio(
          "setEvar",
          "popScrean_var",
          this.pageCode == "1" ? "首页" : "支付成功页"
        );
      });
    },
    trackBombscreen(item) {
      let randomKey = localStorage.getItem("uuid");
      if (!randomKey) {
        randomKey = this.get_uuid();
      }
      let current_data = {
        randomKey: randomKey,
      };
      if(item.sourceType == 1) {
        current_data.code = item.code
      } else {
        current_data.notifyId = item.notifyId
      }
      http({
        url: "/order/app/popup-rule/popupRuleClick",
        method: "post",
        parmes: current_data,
      }).then((rps) => {});
    },
    get_uuid: function () {
      let s = [];
      let hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4";
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    },
    onJumpSceneDetail: function (item, type) {
      let target = item[type];
      this.trackBombscreen(item);
      switch (target.tm) {
        case "4020001":
          this.onGetBombHidden();
          break;
        case "4020002":
          this.$router.go(-1);
          this.bombStatus = false;
          break;
        case "4000100":
          if (target.tp.url) {
            utils.jumpToNewPage({
              url: target.tp.url,
              barColor: target.tp.barColor,
            });
          }
          this.bombStatus = false;
          break;
        case "4030100":
          // this.$router.push({
          //   path: "/commoditydetails",
          //   query: { id: target.tp.id },
          // });
        var obj = {goodsId:parseInt(target.tp.id)};
         utils.jumpToNewPage({
              url: window.location.origin + "/h5user/commoditydetails?id=" + target.tp.id,
              noTitle: "0",
              action:{tm:"4030100",tp:obj}
          });

          this.bombStatus = false;
          break;
        case "4030200":
          this.$router.push({
            path: "/markentindex",
            query: { id: target.tp.id },
          });
          this.bombStatus = false;
          break;
        case "4030300":
          this.$router.push({
            path: "/brandindex",
            query: { id: target.tp.id },
          });
          this.bombStatus = false;
          break;
        case "4040100":
          this.$router.push({
            path: "/discoverHottopic",
            query: { hotId: target.tp.id },
          });
          this.bombStatus = false;
          break;
      }
      gio(
        "track",
        type == "button1Target"
          ? "popScreenLeftButtonClick_var"
          : "popScreenRightButtonClick_var",
        {
          popScreanID_var: item.id,
          popScreanName_var: item.name,
          popScreanCloseButtonClick_var: 1,
        }
      );
    },
    onGetBombHidden: function () {
      var bombScreenIndex = this.bombScreenIndex + 1;
      if (this.bombScreenList.length < bombScreenIndex) {
        this.bombStatus = false;
      } else {
        this.bombScreenIndex = bombScreenIndex;
      }
      gio("track", "popScreanCloseButtonClick_var", {
        popScreanID_var: this.bombScreenList[this.bombScreenIndex - 1].id,
        popScreanName_var: this.bombScreenList[this.bombScreenIndex - 1].name,
        popScreanCloseButtonClick_var: 1,
      });
    },
    /**
     * 此函数由父组件发起调用，作用：如果父组件已经退出当前页销毁继续轮询接口
     */
    stopQueryCount(){
      this.queryCount = 6;
    }
  },
};
</script>

<style lang="less" scoped>
.index-bombscreen-back {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10009;
  background-color: rgba(0, 0, 0, 0.5);
}
.index-index-bombscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10010;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
}
.index-bombscreen-messa {
  position: relative;
  width: 720px;
  margin: 0 auto;
}
.index-bombscreen-messa .image img {
  display: block;
  width: 100%;
}
.index-bombscreen-messa .button1 {
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.index-bombscreen-messa .button1 img {
  display: block;
  width: 255px;
  height: auto;
  margin: 0 15px;
}
.index-bombscreen-messa .button2 {
  position: absolute;
  bottom: 33px;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.index-bombscreen-messa .button2 img {
  display: block;
  width: 380px;
  height: auto;
  margin: 0 15px;
}
.index-bombscreen-cancel img {
  width: 80px;
  height: 80px;
  margin-top: 12px;
}
</style>